module.exports = __webpack_public_path__ + "media/images/athletes/1868-a3c1f9f60f7d3921804160b8771c74bc.png";